/* eslint-disable @typescript-eslint/no-explicit-any */
import ImagePath from 'app/utilities/imagePath';
import { RootState } from 'app/redux/store';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { passwordRegex } from 'constants/regex';
import { IModalProps } from 'app/interfaces/modalProps.interface';
import Button from '../Button/Button';
import InputComponent from '../InputComponent/InputComponent';
import { setNewPasswordAction, ISetNewPasswordRequest, setResetErrorAndMessageAction } from '../../redux/actions/ChangePasswordAction';
import './ChangePassword.scss';

const FORM_INDEX = {
	OLD_PASSWORD: 0,
	NEW_PASSWORD: 1,
	CONFIRM_NEW_PASSWORD: 2
};

const ChangePassword = function init(props: IModalProps): React.ReactElement {
	const dispatch = useDispatch();
	const [isInvalid, setInvalid] = useState(true);
	const { setOpenModal } = props;
	const changePasswordState = useSelector((state: RootState) => state.changePasswordReducer);
	const { error, message } = changePasswordState;
	const [form, setForm] = useState([
		{
			id: 'oldPassword',
			formType: 'password',
			placeholder: 'Kata Sandi Lama',
			name: 'oldPassword',
			apiErrorMessage: '',
            value: ''
		},
		{
			id: 'newPassword',
			formType: 'password',
			placeholder: 'Kata Sandi Baru',
			name: 'newPassword',
			apiErrorMessage: '',
            value: ''
		},
		{
			id: 'confirmNewPassword',
			formType: 'password',
			placeholder: 'Ketik Ulang Kata Sandi Baru',
			name: 'confirmNewPassword',
			apiErrorMessage: '',
            value: ''
		},
	]);
	const onHandleSubmit = useCallback((event: ChangeEvent<any>): void => {
		event.preventDefault();
		const { oldPassword, newPassword, confirmNewPassword } = event.target.elements;
		const payload: ISetNewPasswordRequest = {
			oldPassword: oldPassword.value,
			newPassword: newPassword.value,
			confirmNewPassword: confirmNewPassword.value
		};
		dispatch(setNewPasswordAction(payload));
	}, []);

	function checkValidation(): void {
		let invalid = false;

		form[FORM_INDEX.OLD_PASSWORD].apiErrorMessage = error || '';
		if (form[FORM_INDEX.NEW_PASSWORD].value !== '' && !passwordRegex.test(form[FORM_INDEX.NEW_PASSWORD].value)) {
			form[FORM_INDEX.NEW_PASSWORD].apiErrorMessage = 'Kata Sandi harus terdiri dari min 8 karakter, huruf besar, huruf kecil dan angka';
		} else {
			form[FORM_INDEX.NEW_PASSWORD].apiErrorMessage = '';
		}
		if (form[FORM_INDEX.CONFIRM_NEW_PASSWORD].value !== ''
			&& form[FORM_INDEX.CONFIRM_NEW_PASSWORD].value !== form[FORM_INDEX.NEW_PASSWORD].value) {
			form[FORM_INDEX.CONFIRM_NEW_PASSWORD].apiErrorMessage = 'Kata Sandi harus sama dengan Kata Sandi Baru';
			invalid = true;
		} else {
			form[FORM_INDEX.CONFIRM_NEW_PASSWORD].apiErrorMessage = '';
		}
		const updateForm = [
			...form
		];
		setForm(updateForm);
		form.forEach((each) => {
            if (each.value === '') {
                invalid = true;
            }
			if (each.apiErrorMessage !== '') {
				invalid = true;
			}
        });
        setInvalid(invalid);
	}

	function onChangeHandle(event: Record<string, string>): void {
        const fieldForm = form.find((field) => field.name === event.name);
        if (fieldForm) {
            fieldForm.value = event.value;

            checkValidation();
        }
    }

	function closeModal(): void {
		if (error !== '') {
			dispatch(setResetErrorAndMessageAction(''));
		}
		setOpenModal(false);
	}

	useEffect(() => {
		checkValidation();
	}, [error]);

	useEffect(() => {
		if (message === 'success') {
			closeModal();
			dispatch(setResetErrorAndMessageAction(''));
		}
	}, [message]);

    return (
        <div className="changePassword">
			<div className="titleContainer">
				<h3> Ubah Kata Sandi </h3>
				<button
					className="imageContainer btn"
					type="button"
					onClick={() => closeModal()}
				>
					<img src={ImagePath.close.src} alt={ImagePath.close.alt} />
				</button>
			</div>
			<p> Buat kata sandi yang kuat untuk mengamankan akun </p>
			<form onSubmit={onHandleSubmit}>
				{ form.map((each) => (
					<InputComponent
						key={each.id}
						id={each.id}
						formType={each.formType}
						placeholder={each.placeholder}
						name={each.name}
						apiErrorMessage={each.apiErrorMessage}
                        value={each.value}
                        onChange={(event) => { onChangeHandle(event); }}
					/>
				))}
				<Button
					buttonText="Selanjutnya"
					disabled={isInvalid}
				/>
			</form>
        </div>
    );
};

export default ChangePassword;
